import type { ReactNode } from 'react'

import { Container, Unit, Value } from './components'
import type { MetricValueSize, MetricValueVariant } from './components'

interface Props {
  containerWidth?: number
  value?: ReactNode
  unit?: ReactNode
  size?: MetricValueSize
  valueWidth?: number
  variant?: MetricValueVariant
}

export const MetricValue: React.FC<Props> = ({
  containerWidth,
  value,
  unit,
  size = 'default',
  valueWidth,
  variant = 'compact',
}) => {
  return (
    <Container $containerWidth={containerWidth} $size={size} $variant={variant}>
      <Value $size={size} $valueWidth={valueWidth} $variant={variant}>
        {value ?? '-'}
      </Value>
      {unit !== null && unit !== undefined && (
        <Unit $size={size} $variant={variant}>
          {unit}
        </Unit>
      )}
    </Container>
  )
}
